import axios from 'axios';
import { API_URL } from 'constants/config';
import ls from 'localstorage-slim';
import Log from 'lib/Log';
// enable global encryption
ls.config.encrypt = true;

// get all questions
export const getDynamicFieldList = async (payload) => {
  const headers = {
    Authorization: `Bearer ${ls.get('token') || payload?.token}`,
    organisationid: ls.get('orgId') || payload.orgId,
  };
  const query = {
    search: payload.search,
    sort: payload.sort,
    sortBy: payload.sortBy,
    currentPage: payload.currentPage,
    perPage: payload.perPage,
    type: payload?.type,
    program: payload?.program,
  };
  try {
    return await axios.get(`${API_URL}/admin/apprenticeship-program/registration-dynamic-fields/list`, { params: query, headers });
  } catch (err) {
    throw new Error(err);
  }
};

export const saveDynamicField = async (payload) => {
  try {
    const headers = {
      headers: {
        Authorization: `Bearer ${ls.get('token')}`,
        organisationid: ls.get('orgId'),
      },
    };

    return await axios.post(`${API_URL}/admin/apprenticeship-program/registration-dynamic-fields/create`, payload, headers);
  } catch (err) {
    throw err.response?.data || err;
  }
};

export const deleteDynamicField = async ({ orgId, id }) => {
  try {
    const headers = {
      Authorization: `Bearer ${ls.get('token')}`,
      organisationid: ls.get('orgId') || orgId,
    };
    return await axios.delete(`${API_URL}/admin/apprenticeship-program/registration-dynamic-fields/${id}/delete`, { headers });
  } catch (err) {
    Log.error('Error >> ', err);
    throw err.response?.data || err;
  }
};

export const updateDynamicFieldTitle = async (payload) => {
  try {
    const headers = {
      headers: {
        Authorization: `Bearer ${ls.get('token')}`,
        organisationid: ls.get('orgId'),
      },
    };

    return await axios.post(`${API_URL}/admin/apprenticeship-program/registration-dynamic-fields/update/title`, payload, headers);
  } catch (err) {
    throw err.response?.data || err;
  }
};

export const getDynamicFieldById = async (payload) => {
  const headers = {
    headers: {
      organisationid: ls.get('orgId'),
      Authorization: `Bearer ${ls.get('token')}`,
    },
  };
  try {
    return await axios.get(`${API_URL}/admin/apprenticeship-program/registration-dynamic-fields/${payload.id}`, headers);
  } catch (err) {
    Log.error(err);
  }
};

export const updateDynamicField = async (payload) => {
  try {
    const headers = {
      headers: {
        Authorization: `Bearer ${ls.get('token')}`,
        organisationid: ls.get('orgId'),
      },
    };

    return await axios.post(`${API_URL}/admin/apprenticeship-program/registration-dynamic-fields/update`, payload, headers);
  } catch (err) {
    throw err.response?.data || err;
  }
};
